import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { getKnowledgeGraphStats } from "@/lib/kg.seed.functions";
import { ADRS } from "@/content/adr";

export const Route = createFileRoute("/admin/")({
  component: AdminOverview,
});

function AdminOverview() {
  const statsFn = useServerFn(getKnowledgeGraphStats);
  const { data, isLoading, error } = useQuery({
    queryKey: ["admin", "kg-stats"],
    queryFn: () => statsFn(),
  });

  return (
    <div className="space-y-10">
      <section>
        <p className="overline mb-2">Knowledge graph</p>
        <h2 className="font-serif text-2xl text-primary mb-4">Current corpus</h2>
        <div className="border border-border bg-card p-6">
          {isLoading && <p className="text-ink-tertiary text-sm">Loading…</p>}
          {error && (
            <p className="text-sm text-destructive">
              {error instanceof Error ? error.message : "Failed to load stats"}
            </p>
          )}
          {data && (
            <>
              <p className="font-serif text-4xl text-primary mb-4">
                {data.total} <span className="text-base text-ink-tertiary font-sans">nodes</span>
              </p>
              <ul className="grid grid-cols-2 sm:grid-cols-3 gap-3 text-sm">
                {Object.entries(data.by_type).map(([type, count]) => (
                  <li key={type} className="flex justify-between border-b border-border/50 pb-1">
                    <span className="font-mono text-ink-secondary">{type}</span>
                    <span className="font-mono text-primary">{count}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-6">
                <Link
                  to="/admin/kg"
                  className="text-sm text-primary underline underline-offset-4 hover:no-underline"
                >
                  Seed / re-embed →
                </Link>
              </div>
            </>
          )}
        </div>
      </section>

      <section>
        <p className="overline mb-2">Architecture references</p>
        <h2 className="font-serif text-2xl text-primary mb-4">Decisions on record</h2>
        <ul className="border border-border bg-card divide-y divide-border">
          {ADRS.map((adr) => (
            <li key={adr.id}>
              <Link
                to="/admin/references/$id"
                params={{ id: adr.id }}
                className="block p-5 hover:bg-muted/50"
              >
                <div className="flex items-baseline justify-between">
                  <span className="font-mono text-xs text-ink-tertiary">{adr.number}</span>
                  <span className="text-xs text-ink-tertiary">{adr.date}</span>
                </div>
                <p className="font-serif text-lg text-primary mt-1">{adr.title}</p>
                <p className="text-xs font-mono text-ink-secondary mt-1">{adr.status}</p>
              </Link>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
